import type { UUID } from "@/core/types";

export const patientKeys = {
  base: ["patient"] as const,
  details: (id: UUID) => [...patientKeys.base, id, "details"] as const,
  diagnosis: (id: UUID) => [...patientKeys.base, id, "diagnosis"] as const,
  files: (id: UUID) => [...patientKeys.base, id, "files"] as const,
} as const;
